export var PLAYER_NOTIFICATIONS;
(function (PLAYER_NOTIFICATIONS) {
    PLAYER_NOTIFICATIONS["PLAYER_READY"] = "PLAYER_READY";
    PLAYER_NOTIFICATIONS["PLAY_EVENT"] = "PLAY_EVENT";
    PLAYER_NOTIFICATIONS["PAUSE_EVENT"] = "PAUSE_EVENT";
    PLAYER_NOTIFICATIONS["TRANSITION_EVENT"] = "TRANSITION_EVENT";
    PLAYER_NOTIFICATIONS["SELECT_EVENT"] = "SELECT_EVENT";
    PLAYER_NOTIFICATIONS["UNSELECT_ALL_EVENT"] = "UNSELECT_ALL_EVENT";
    PLAYER_NOTIFICATIONS["PLAY_URL"] = "PLAY_URL";
    PLAYER_NOTIFICATIONS["NEXT_URL"] = "NEXT_URL";
    PLAYER_NOTIFICATIONS["PREVIOUS_URL"] = "PREVIOUS_URL";
    PLAYER_NOTIFICATIONS["SNAPSHOT_EVENT"] = "SNAPSHOT_EVENT";
    PLAYER_NOTIFICATIONS["NEXT_SESSION"] = "NEXT_SESSION";
    PLAYER_NOTIFICATIONS["PREVIOUS_SESSION"] = "PREVIOUS_SESSION";
    PLAYER_NOTIFICATIONS["EVENT_STREAM_SEARCH_NAVIGATION_CONFIG"] = "EVENT_STREAM_SEARCH_NAVIGATION_CONFIG";
    PLAYER_NOTIFICATIONS["EVENT_STREAM_URL"] = "EVENT_STREAM_URL";
    PLAYER_NOTIFICATIONS["SWITCH_PLAYER"] = "SWITCH_PLAYER";
    PLAYER_NOTIFICATIONS["REDIRECT_TO_CONSOLE_API_ERRORS_SETTINGS"] = "REDIRECT_TO_CONSOLE_API_ERRORS_SETTINGS";
})(PLAYER_NOTIFICATIONS || (PLAYER_NOTIFICATIONS = {}));
//# sourceMappingURL=player-notifications.js.map